<template>
  <div class="FormSelect form-group">
    <slot name="label">
      <label v-if="label" class="control-label">
        {{label}}
      </label>
    </slot>

    <div class="select-wrapper d-flex" :class="{ske}">
      <div class="select-inner-wrapper">
        <select v-model="selected"
          class="form-select form-control"
          :aria-label="label"

          v-bind="$attrs"

          @focus="showing = true"
          @blur="showing = false"
        >
          <option v-for="item in options" :key="item.value"
            :value="item.value"
            :selected="item.value === selected"

            @click="selected = item.value"
          >
            {{ item.str }}
          </option>
        </select>

        <div class="border-line"></div>
        <span class="arrow" :class="{showing}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="#bebfc1">
            <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  inheritAttrs: false,
  name: "BaseSelect",
  props: {
    value: {
      type: [String, Number],
      required: false,
    },
    ske: {
      type: Boolean,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    sortingOptions: {
      type: Boolean,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    default: [String, Number]
  },
  data() {
    return {
      selected: this.value || this.options[0].value,
      showing: false,
      sort: "",
    }
  },
  created() {
    this.$emit("input", this.selected)
    if (this.default) this.$emit("input", this.default)
  },
  watch: {
    value(val) {
      this.selected = val
    },
    selected(val) {
      this.$emit("input", val)
    },
  },
}

</script>

<style scoped>

.control-label {
  font-size: 1.08em !important;
  font-weight: 450;
  margin-bottom: 2px;
  color: #000000;
}

/* select {
  border: 1px solid #bebfc1 !important;
} */

.border-line {
  position: absolute;
  right: 0;
  top: 0;
  margin-right: 35px;
  height: 100%;
  width: 1px;
  background-color: #E3E3E3;
}

.custom-select {
  border: none;
  outline: 0;
}

.select-wrapper {
  position: relative;
}

.select-inner-wrapper {
  flex-basis: 100%;
  position: relative;
}

.arrow {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  color: #E3E3E3;
}

.arrow, svg {
  transition-duration: .15s;
}

.showing {
  color: #212529;
}

svg {
  transform: rotate(0deg);
}

.showing svg {
  transform: rotate(-90deg);
}

</style>

<style>

.table-wrapper select, .table-wrapper option {
  font-size: 0.75em !important;
}

.table-wrapper .form-select {
  padding: 4px 6px !important;
  height: unset;
}

.table-wrapper .form-select {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

</style>
